import React from 'react';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
import { LoadingSpinner } from '../../atoms/Progress/LoadingSpinner';

export interface LoadProps {
  /** covers the page in its own background, so what is loading behind stays unseen */
  opaque?: boolean;
  label?: string;
}

export default function Load({ opaque = false, label }: LoadProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: opaque ? 'background.default' : 'rgba(255, 255, 255, 0.85)',
        backdropFilter: opaque ? undefined : 'blur(8px)',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <LoadingSpinner
        size={80}
        thickness={4.5}
        variant="indeterminate"
        sx={{
          color: 'primary.main',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
            animationDelay: '-0.7s',
          },
        }}
      />
      {label && (
        <Text variant="body1" color="text.secondary">
          {label}
        </Text>
      )}
    </Box>
  );
}
